/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_HideInputs */



/**
* | output |
* | --- |
* | "Hide setup" |
*
* @param {My_Integrations_Mcp_Access_HideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_hide = /** @type {((inputs?: My_Integrations_Mcp_Access_HideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_HideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einrichtung ausblenden")
	return /** @type {LocalizedString} */ ("Hide setup")
});